import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import CustomButton from "../elements/CustomButton";

export function DialogConfirmar({ element, onClick, setOpen, open, text }) {
	return (
		<Dialog
			open={open}
			onClose={() => setOpen(false)}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			disableScrollLock
			maxWidth="md"
		>
			<DialogTitle> Vols {element}?</DialogTitle>
			<DialogContent>
				<Typography>{text}</Typography>
			</DialogContent>
			<DialogActions>
				<CustomButton onClick={() => setOpen(false)} title="Tancar" dark fullWidth />
				<CustomButton onClick={onClick} title="Confirmar" success fullWidth />
			</DialogActions>
		</Dialog>
	);
}
